/** Stable anonymous visitor key for activity logging (not auth). */
export const ACTIVITY_ANON_STORAGE_KEY = "coupondealz_activity_anon";

export function getOrCreateActivityAnonKey() {
  try {
    let k = window.localStorage.getItem(ACTIVITY_ANON_STORAGE_KEY);
    if (!k) {
      const id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID().replace(/-/g, "")
          : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`;
      k = `cdz_${id}`;
      window.localStorage.setItem(ACTIVITY_ANON_STORAGE_KEY, k);
    }
    return String(k).trim().slice(0, 128);
  } catch {
    return "cdz_session";
  }
}
